<template>
  <svg
    width="256"
    height="256"
    viewBox="0 0 256 256"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M157.971 84.5376C157.971 40.6784 123.61 5.12 81.2288 5.12C38.848 5.12 4.47998 40.6784 4.47998 84.5376C4.47998 125.549 34.5216 170.592 73.0752 176.275L68.48 194.579H76.16V251.072H84.5888V194.579H93.9776L89.3824 176.275C127.936 170.592 157.978 125.549 157.978 84.5376H157.971Z"
      class="fill-secondary-500"
    />
    <path
      d="M191.917 134.886C191.917 88.1408 154.022 50.24 107.27 50.24C60.5184 50.24 22.624 88.1344 22.624 134.886C22.624 178.829 56.1088 227.117 98.9568 232.755L94.3552 251.072H120.179L115.578 232.755C158.426 227.117 191.91 178.829 191.91 134.886H191.917Z"
      class="fill-brand-500"
    />
    <path
      d="M251.257 108C251.257 51.1808 205.203 5.12 148.384 5.12C91.5647 5.12 45.5039 51.1808 45.5039 108C45.5039 161.28 86.0031 219.814 137.901 226.899L131.834 251.072H164.934L158.867 226.899C210.765 219.814 251.264 161.28 251.264 108H251.257Z"
      class="fill-brand-100"
    />
    <path
      d="M200.915 96.5696L149.978 45.632C149.101 44.7552 147.674 44.7552 146.79 45.632L123.328 69.0944V60.0576C123.328 58.2144 121.837 56.7232 119.987 56.7232H113.651C111.808 56.7232 110.31 58.2144 110.31 60.0576V82.1056L95.84 96.576C94.4192 97.9968 95.424 100.422 97.4336 100.422H102.323V165.882H116.307V127.322C116.307 125.965 117.408 124.864 118.765 124.864H136.32C137.677 124.864 138.778 125.965 138.778 127.322V165.882H194.432V100.422H199.322C201.325 100.422 202.33 97.9968 200.915 96.576V96.5696ZM176.339 137.056H156.998V115.68C156.998 114.509 157.946 113.562 159.117 113.562H174.227C175.398 113.562 176.346 114.509 176.346 115.68V137.056H176.339Z"
      class="fill-brand-300"
    />
  </svg>
</template>

<script>
  export default {
    name: 'ExtendMortgage'
  }
</script>
